import './Login.css';
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import ForgetPassword from './ForgetPassword';
import Login from './Login';
import SignUp from './SignUp';
import { useAppSelector } from '../../hooks/store';

enum Tab {
  LOGIN = 'LOGIN',
  SIGN_UP = 'SIGN_UP',
  FORGET_PASSWORD = 'FORGET_PASSWORD'
}
const GetStarted: React.FC = () => {
  const [tab, setTab] = useState<Tab>(Tab.LOGIN);
  const isAuthenticated = !!useAppSelector(state => state.prop.propId);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/products';

  if (isAuthenticated) {
    navigate(from, { replace: true });
  }
  return (
    <div className="bg flex justify-end">
      <div className="bg-white w-1/3 mt-4 mr-4 mb-4 rounded-md  p-6 ">
        <div className="flex justify-center my-8">
          <div className="flex gap-4 bg-[#f6f6f6] rounded-md p-2">
            <button
              className={`px-6 py-2 font-semibold rounded-md ${
                tab === Tab.LOGIN ? 'bg-[#35e0a1] text-white' : 'text-black'
              }`}
              onClick={() => setTab(Tab.LOGIN)}
            >
              Login
            </button>
            <button
              className={`px-6 py-2 font-semibold rounded-md ${
                tab === Tab.SIGN_UP ? 'bg-[#35e0a1] text-white' : 'text-black'
              }`}
              onClick={() => setTab(Tab.SIGN_UP)}
            >
              Signup
            </button>
          </div>
        </div>
        <div className="flex flex-col justify-center">
          <p className="text-black font-medium text-start">
            Welcome to <span className="text-[#35e0a1] text-3xl font-bold">Zittle</span>
          </p>
          <h1 className="text-black text-2xl font-bold tracking-wide text-start">
            {tab === Tab.LOGIN
              ? 'Get Started with your Email'
              : tab === Tab.SIGN_UP
                ? 'Create a new account'
                : 'Reset your Password'}
          </h1>
          {tab === Tab.LOGIN ? (
            <>
              <Login from={from} />
              <button
                className="text-sm text-blue-600 underline mt-2 text-start"
                onClick={() => setTab(Tab.FORGET_PASSWORD)}
              >
                Forgot Password?
              </button>
            </>
          ) : tab === Tab.SIGN_UP ? (
            <SignUp from={from} />
          ) : (
            <ForgetPassword from={from} />
          )}
        </div>
        {/* <div className="text-gray-300 mt-2 flex justify-center font-medium">or</div>
          <div className="text-gray-400 mt-2 flex justify-center bg-[#f6f6f6] mr-6 h-[35px] items-center font-medium">
            Continue With Google
          </div> */}
        <div className="absolute bottom-6">
          <p className="font-medium">
            By continuing you agree to our
            <br />
            <Link to="/privacy-policy" className="text-[#35e0a1] px-1">
              Privacy policies
            </Link>
            and
            <Link to="/terms" className="text-[#35e0a1] px-1">
              Terms & conditions
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
